'use client';

import {Box, keyframes, styled} from '@mui/material';
import {StyledSectionContainer} from '@/components/sections/shared/Section.styles';
import {
  LOGO_ITEM_GAP,
  LOGO_ITEM_GAP_SM,
  LOGO_ITEM_HEIGHT,
  LOGO_ITEM_HEIGHT_SM,
} from './MarqueeLogoSection.constants';

const scroll = keyframes`
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
`;

export const LogoMarqueeWrapper = styled(StyledSectionContainer)(({theme}) => ({
  width: '100%',
  overflow: 'hidden',
  margin: theme.spacing(6, 0, 10, 0),
  [theme.breakpoints.down('md')]: {
    margin: theme.spacing(5, 0, 9, 0),
  },
  [theme.breakpoints.down('sm')]: {
    margin: theme.spacing(4, 0, 4, 0),
  }
}));

export const LogoMarqueeTrack = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  width: 'fit-content',
  animation: `${scroll} 55s linear infinite`,
  '@media (prefers-reduced-motion: reduce)': {
    animation: 'none',
    transform: 'translateX(0)',
  },
});

export const LogoItemWrapper = styled(Box)(({theme}) => ({
  flexShrink: 0,
  position: 'relative',
  // Fixed height, intrinsic width: each logo occupies exactly as much width as
  // it needs at this height. The trailing margin gives equal space between all.
  height: LOGO_ITEM_HEIGHT,
  marginRight: LOGO_ITEM_GAP,
  '& img': {
    display: 'block',
    width: 'auto',
    height: '100%',
    objectFit: 'contain',
  },
  [theme.breakpoints.down('sm')]: {
    height: LOGO_ITEM_HEIGHT_SM,
    marginRight: LOGO_ITEM_GAP_SM,
  },
}));
